import { useEffect, useState, useCallback } from "react";
import { getAllLoanStatus, addNewLoanStatus, updateLoanStatus, deleteLoanStatus, reactivateLoanStatus } from "../Service";


export default function useLoanStatus() {
  const [page, setPage] = useState(0);
  const [user, setUser] = useState(null);
  const [userList, setUserList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [shouldOpenEditorDialog, setShouldOpenEditorDialog] = useState(false);
  const [shouldOpenConfirmationDialog, setShouldOpenConfirmationDialog] = useState(false);
  const [shouldOpenReactivateConfirmationDialog, setShouldOpenReactivateConfirmationDialog] = useState(false);



  const handleChangePage = (_, newPage) => setPage(newPage);

  const updatePageData = useCallback(() => {
    getAllLoanStatus().then(response => {
      setUserList(response.data.loanStatus || []);
    }).catch(error => {
      console.error('Failed to fetch loan status data', error);
    });
  }, []);


  const handleDialogClose = () => {
    setShouldOpenEditorDialog(false);
    setShouldOpenConfirmationDialog(false);
    setShouldOpenReactivateConfirmationDialog(false);
    updatePageData();
  };

  const handleDeleteUser = (user) => {
    setUser(user);
    setShouldOpenConfirmationDialog(true);
  };

  const handleSaveLoanStatus = async (loanStatusDetails, isNew, setFieldError) => {
    const apiPayload = {
      statusCode: loanStatusDetails.statusCode
    };

    if (isNew) {
      const response = await addNewLoanStatus(apiPayload);
      if (response.data.success) {
        handleDialogClose();
        setTimeout(updatePageData, 500);
        return null;
      } else {
        setFieldError('statusCode', response.data.errorMessage);
        return response.data.errorMessage;
      }
    }
  };

  const handleEditLoanStatus = async (loanStatusDetails, setFieldError) => {
    const apiPayload = {
      id: loanStatusDetails.id,
      statusCode: loanStatusDetails.statusCode
    };

    const response = await updateLoanStatus(apiPayload);
    if (response.data.success) {
      handleDialogClose();
      setTimeout(updatePageData, 500);
      return null;
    } else {
      setFieldError('statusCode', response.data.errorMessage);
      return response.data.errorMessage;
    }
  };

  const handleConfirmationResponse = async () => {
    if (user) {
      const response = await deleteLoanStatus({ id: user.id });
      if (response.data.success) {
        handleDialogClose();
        setTimeout(updatePageData, 500);
      }
    }
  };

  const handleReactivateLoanStatus = (user) => {
    setUser(user);
    setShouldOpenReactivateConfirmationDialog(true);
  };

  const handleReactivateConfirmationResponse = async () => {
    if (user) {
      const response = await reactivateLoanStatus({ id: user.id });
      if (response.data.success) {
        handleDialogClose();
        setTimeout(updatePageData, 500);
      }
    }
  };

  const handleEditUser = (user) => {
    setUser(user);
    setShouldOpenEditorDialog(true);
  };


  useEffect(() => {
    updatePageData();
  }, [updatePageData]);


  return {
    page,
    user,
    setUser,
    userList,
    rowsPerPage,
    setRowsPerPage,
    handleSaveLoanStatus,
    handleEditUser,
    handleDeleteUser,
    handleChangePage,
    handleDialogClose,
    shouldOpenEditorDialog,
    setShouldOpenEditorDialog,
    handleConfirmationResponse,
    shouldOpenConfirmationDialog,
    handleEditLoanStatus,
    handleReactivateLoanStatus,
    handleReactivateConfirmationResponse,
    shouldOpenReactivateConfirmationDialog,
    updatePageData
  };
}
